import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {LayoutModule} from '../../layout/layout.module';
import {EditorModule} from 'primeng/editor';
import {CoreModule} from '../../core/core.module';
import {NotesModule} from '../../notes/notes.module';
import {COMPONENTS, COMPONENTS_EXPORTS, SERVICES} from '@ispm/dashboard/disclaimer-viewer/index';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    EditorModule,
    LayoutModule,
    CoreModule,
    NotesModule
  ],
  declarations: [...COMPONENTS],
  providers: [...SERVICES],
  exports: [...COMPONENTS_EXPORTS]
})

export class DisclaimerViewerModule { }

